import { z } from "zod";

const COMMENT_MAX_LENGTH = 1000;

export const workflowStartSchema = z.object({
	comment: z
		.string()
		.max(
			COMMENT_MAX_LENGTH,
			`コメントは${COMMENT_MAX_LENGTH.toLocaleString()}文字以内で入力してください`
		),
	proceedWithoutApproval: z.boolean(),
	workflowUuid: z.string().min(1, "ワークフローを選択してください")
});

export type WorkflowStartFormValues = z.infer<typeof workflowStartSchema>;

export const buildDefaultWorkflowStartFormValues =
	(): WorkflowStartFormValues => ({
		comment: "",
		proceedWithoutApproval: false,
		workflowUuid: ""
	});

export const buildResetWorkflowStartFormValues = (
	currentValues: WorkflowStartFormValues,
	workflowUuid: string
): WorkflowStartFormValues => ({
	...buildDefaultWorkflowStartFormValues(),
	comment: currentValues.comment,
	workflowUuid
});
